const formatStreetAddress = (address1: string, address2: string | undefined | null) => {
    return address2 ? `${address1}, ${address2}` : address1;
};
export { formatStreetAddress };
